var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info-widget-container"},[_c('div',{staticClass:"info-widget-container__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"info-widget-container__info"},[_vm._v(_vm._s(_vm.info))]),_c('div',{staticClass:"info-widget-container__subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }